import { jsxs as h, jsx as e } from "react/jsx-runtime";
import { zIndices as w } from "@fcamna/shared-component-foundations";
import B, { useState as T, useEffect as b, useCallback as f } from "react";
import { createPortal as $ } from "react-dom";
import s, { css as i } from "styled-components";
import { u as y } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { c as C } from "./index-65016bfa.mjs";
import { CloseButton as N } from "./closeButton.js";
import { Icon as W } from "./icon.js";
import { ButtonV1 as I } from "./buttonV1.js";
import { Button as z } from "./button.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./iconButton.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "@fcamna/shared-icons";
import "./Aria-f5e019e2.mjs";
import "./combineRefs-90f27925.mjs";
const L = s.div`
  &.Snackbar-wrapper {
    ${({
  theme: {
    components: { snackbar: o }
  }
}) => i(o.SnackbarWrapper)};
  }
`, P = s.div`
  &.Snackbar-container {
    ${({
  theme: {
    components: { snackbar: o }
  }
}) => i(o.Container)};
  }
`, _ = s.p`
  &.Snackbar-text {
    ${({
  theme: {
    components: { snackbar: o }
  }
}) => i(o.Text)};
  }
`, q = s(I)`
  &.SnackbarButton {
    ${({
  theme: {
    components: { snackbar: o }
  }
}) => i(o.SnackbarButton)};
  }
`, E = s.div`
  &.LogoWrapper {
    ${({
  theme: {
    components: { snackbar: o }
  }
}) => i(o.LogoWrapper)};
  }
`, F = ({
  message: o,
  buttonText: a,
  showCloseIcon: m = !1,
  type: r,
  id: l,
  logo: n,
  onButtonClick: t,
  autoCloseTime: p = 3e3
}) => {
  const c = p, { removeSnackBar: k } = x(), [d, S] = T(!1);
  b(() => {
    const u = setTimeout(() => {
      S(!0);
    }, c);
    return () => {
      clearTimeout(u);
    };
  }, [c]), b(() => {
    const u = setTimeout(() => {
      d && k(Number(l));
    }, c);
    return () => {
      clearTimeout(u);
    };
  }, [d, l, k, c]);
  const g = (u) => {
    S(!0);
  };
  return /* @__PURE__ */ h(
    L,
    {
      className: C([
        "Snackbar-wrapper",
        `Snackbar-wrapper--${r}`,
        { "Snackbar-wrapper--fadeOut": d }
      ]),
      role: "alert",
      children: [
        n && typeof n == "string" ? /* @__PURE__ */ e(
          W,
          {
            name: n,
            size: "m"
          }
        ) : n && /* @__PURE__ */ e(E, { className: "LogoWrapper", children: n }),
        /* @__PURE__ */ e(P, { className: "Snackbar-container", children: /* @__PURE__ */ e(_, { className: "Snackbar-text", children: o }) }),
        a && /* @__PURE__ */ e(
          q,
          {
            size: "small",
            variant: r == "error" ? "secondary" : "primary",
            color: r == "primary" ? "default" : r == "error" ? "danger" : "default",
            className: C(["SnackbarButton", `SnackbarButton--${r}`]),
            onClick: t,
            children: a
          }
        ),
        m && /* @__PURE__ */ e(
          N,
          {
            surface: "dark",
            size: "small",
            onClick: () => g()
          }
        )
      ]
    }
  );
}, M = s.div`
  &.Snackbar-container--wrapper {
    ${({
  theme: {
    components: { snackbar: o }
  }
}) => i(o.SnackbarContainerWrapper)};
  }
`, Q = ({ snackbars: o, style: a }) => {
  const m = y({ label: "Snackbar" });
  return $(
    /* @__PURE__ */ e(
      M,
      {
        className: "Snackbar-container--wrapper",
        style: a,
        ...m,
        children: o.map((r) => /* @__PURE__ */ e(
          F,
          {
            id: r.id.toString(),
            message: r.message,
            buttonText: r.buttonText,
            logo: r.logo,
            showCloseIcon: r.showCloseIcon,
            onButtonClick: r.onButtonClick,
            type: r.type,
            autoCloseTime: r.autoCloseTime
          },
          r.id
        ))
      }
    ),
    document.body
  );
}, v = B.createContext(void 0);
let R = 0;
const mr = ({ children: o, zIndex: a = w.toast }) => {
  const [m, r] = T([]), l = f(
    (t) => {
      r((p) => [
        ...p,
        {
          id: R++,
          message: t.message,
          buttonText: t.buttonText,
          logo: t.logo,
          type: t.type,
          showCloseIcon: t.showCloseIcon,
          onButtonClick: t.onButtonClick,
          autoCloseTime: t.autoCloseTime
        }
      ]);
    },
    [r]
  ), n = f(
    (t) => {
      r((p) => p.filter((c) => c.id !== t));
    },
    [r]
  );
  return /* @__PURE__ */ h(v.Provider, { value: { addSnackBar: l, removeSnackBar: n }, children: [
    /* @__PURE__ */ e(
      Q,
      {
        snackbars: m,
        style: { zIndex: a }
      }
    ),
    o
  ] });
}, x = () => B.useContext(v), pr = ({ snackbar: o }) => {
  const { addSnackBar: a } = x();
  return /* @__PURE__ */ e(
    z,
    {
      onClick: () => a(o),
      size: "small",
      variant: "solid",
      children: "Snackbar"
    }
  );
};
export {
  mr as SnackbarProvider,
  pr as SnackbarStory,
  x as useSnackbars
};
